import * as React from 'react';

import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';
import {Content, Header} from 'common/onboarding/immersive-onboarding/components';
import rocketImg from 'common/onboarding/immersive-onboarding/assets/rocket.svg';
import {useTranslation} from 'common/i18n/hooks';

import {WelcomeWithPlannedEvents} from './v2/welcome-with-plan';
import {WelcomeV2Default} from './v2/welcome-v2-default';

export const WelcomePhase2 = () => {
  const {t} = useTranslation();
  const {setupGuideInfo, completed} = React.useContext(SetupGuideContext);
  const {stepsCompleted} = setupGuideInfo;
  const hasPlannedEvents = stepsCompleted.has(Step.Events);

  return (
    <>
      <Header
        title={t(`onboarding.welcome.start-here`)}
        step={t(`onboarding.welcome.step-one`)}
        imgSrc={rocketImg}
        duration={3}
        completed={completed[Step.Welcome]}
      />
      <Content>{hasPlannedEvents ? <WelcomeWithPlannedEvents /> : <WelcomeV2Default />}</Content>
    </>
  );
};
